import ROUTES from 'consts/routesConsts'

export const SupportRestrictedPaths = [ROUTES.NOTIFICATION_SETTINGS, ROUTES.BILLING, ROUTES.SERVICE]
export const DSORestrictedPaths = [ROUTES.SUPPORT_DASHBOARD, ROUTES.DOC_STATS]
